<div class="working-area" [class.is-dragging]="$isDragging()" [class.is-directory-mode]="$isInDirectory()" [class.has-directories]="$hasDirectories()">
    <!-- Lista de Fluxos -->
    <div class="cards-container styled-scrollbar hint-mode-reference">
        <ngx-spinner bdColor="rgba(255, 255, 255, 1)" size="medium" color="#64b2cd" type="line-scale-pulse-out-rapid" [fullScreen]="false"></ngx-spinner>

        @if ($isBootstrapFinished()) {
            <!-- Lista vazia -->
            @if ($isInDirectory() && $filteredFlowDefinitions().length == 0) {
                <div class="card empty">Nenhum item a exibir</div>
            }

            <div class="cards">
                @if (!$isInDirectory()) {
                    @if (!$isCreatingDirectory()) {
                        <div class="add-container-wrapper" [style.visibility]="$isFlowItemVisible() ? 'visible' : 'hidden'">
                            <div class="mini-add-card flow" matTooltip="Criar Novo Fluxo" (click)="newFlowDefinition()">
                                <i class="fas fa-plus-circle"></i>
                                <span>Novo Fluxo</span>
                            </div>

                            <div class="mini-add-card folder" matTooltip="Criar Nova Pasta" (click)="prepareCreationDirectory()">
                                <i class="fas fa-folder-plus"></i>
                                <span>Nova Pasta</span>
                            </div>
                        </div>
                    }

                    @if ($isCreatingDirectory()) {
                        <flow-inbox-directory-item [style.visibility]="$isFlowItemVisible() ? 'visible' : 'hidden'"
                                                   [_mode]="flowInboxDirectoryMode.Creating"
                                                   (_confirmEvent)="saveDirectory($event)"
                                                   (_cancelEvent)="cancelCreationDirectory()"
                        ></flow-inbox-directory-item>
                    }

                    @for (flowInboxDirectory of $flowInboxDirectories(); track flowInboxDirectory?.id) {
                        <div class="directory-wrapper">
                            <flow-inbox-directory-item cdkDropList cdkDropListSortingDisabled
                                                       [style.visibility]="$isFlowItemVisible() ? 'visible' : 'hidden'"
                                                       [class.drag-hovering]="$activeHoverTargetId() == flowInboxDirectory.id"
                                                       [id]="flowInboxDirectory.id"
                                                       [_mode]="flowInboxDirectoryMode.Viewing"
                                                       [_flowInboxDirectory]="flowInboxDirectory"
                                                       (_prepareCreateEvent)="prepareCreationDirectory()"
                                                       (_openEvent)="openDirectory($event)"
                                                       (_confirmEvent)="updateDirectory($event, flowInboxDirectory)"
                                                       (_deleteEvent)="deleteDirectory($event)"
                                                       (_cancelEvent)="cancelCreationDirectory()"
                                                       (_actionEvent)="redirectToAction($event)"
                                                       (cdkDropListDropped)="dragDropped($event, flowInboxDirectory.id)"
                                                       (mouseenter)="$activeHoverTargetId.set(flowInboxDirectory.id)"
                                                       (mouseleave)="$activeHoverTargetId.set(null)"
                            ></flow-inbox-directory-item>

                             <!-- Fechar Modo Adicionar na Pasta -->
                            @if (shouldShowExitDirectoryButton(flowInboxDirectory)) {
                                <button type="button" class="btn btn-secondary exit-directory"
                                        (click)="exitContextMode()"
                                        (keyDown)="exitContextMode()"
                                >
                                    <i class="fas fa-check mr-2"></i>
                                    <span>Concluir</span>
                                </button>
                            }
                        </div>
                    }
                }
                @for (context of $flowDefinitionContexts(); track context) {
                    <!-- Agrupamento -->
                    @if (hasFilteredFlowDefinition(context)) {
                        <div cdkDropList cdkDropListSortingDisabled #flowContextWrapperRef
                             [cdkDropListConnectedTo]="$dragTargetIds()"
                        >
                            <div cdkDrag class="flow-definition-context" #contextRef
                                 [cdkDragDisabled]="$isInDirectory() || !$hasDirectories()"
                                 [cdkDragData]="context"
                                 (cdkDragReleased)="dragReleased($event)"
                                 (cdkDragStarted)="dragStarted()"
                                 (cdkDragEnded)="dragEnded()"
                            >
                                <ngx-spinner [name]="context.id" class="flow-definition-item" bdColor="rgba(255, 255, 255, 1)" size="medium" color="#64b2cd" type="line-scale-pulse-out-rapid" [fullScreen]="false"></ngx-spinner>

                                <!-- Editar -->
                                @if (shouldShowEditContext(context)) {
                                    <i class="fas fa-edit edit-context" featureHint="flowDefinitionContext|Name" #editContextButtonRef
                                       matTooltipPosition="above"
                                       matTooltip="Editar nome do Agrupamento"
                                       (click)="toggleEditContext(context)"
                                       (keyDown)="toggleEditContext(context)"
                                    ></i>
                                }

                                <!-- Nome do Agrupamento -->
                                @if ($shouldShowEditContextInput() && $currentEditContextId() == context.id) {
                                    <input type="text" class="form-inline" placeholder="Nome do Agrupamento" maxlength="50" #editContextInputRef
                                           [(ngModel)]="context.name"
                                           (keyup.enter)="toggleEditContext(context)"
                                           (change)="contextNameChange()"
                                    />
                                }

                                <!-- Fechar Modo Agrupamento -->
                                @if (shouldShowExitContextButton(context)) {
                                    <button type="button" class="btn btn-secondary exit-context"
                                            (click)="exitContextMode()"
                                            (keyDown)="exitContextMode()"
                                    >
                                        <i class="fas fa-check mr-2"></i>
                                        <span>Concluir</span>
                                    </button>
                                }

                                @for (flow of context.flowDefinitions; track flow) {
                                    <!-- Fluxo -->
                                    @if (isFilteredFlowDefinition(flow)) {
                                        <flow-definition-item class="flow-definition-item" featureHint="flowDefinitionItem" featureHintVAlign="top" #flowItemRef
                                                              [style.visibility]="$isFlowItemVisible() ? 'visible' : 'hidden'"
                                                              [_model]="flow"
                                                              [_isContextMode]="$isContextMode()"
                                                              [_isLastContextIndex]="isLastContextIndex(flow)"
                                                              [_hasReachedMaxLimit]="$hasReachedMaxLimit()"
                                                              [_hasFilteredFlowItemInContext]="hasFilteredFlowItemInContext(context.id)"
                                                              [_contextModeDispatcherId]="$contextModeDispatcher()?.id"
                                                              [_dispatcherContextId]="$contextModeDispatcher()?.contextId"
                                                              [_isDispatcherDiretory]="!$contextModeDispatcher()?.version"
                                                              [_isRemovingFromDirectory]="$isRemovingFromDirectory()"
                                                              (_actionEvent)="redirectToAction($event)"
                                        ></flow-definition-item>
                                    }
                                }

                                <!-- Mover para a raiz -->
                                @if ($isRemovingFromDirectory()) {
                                    <button type="button" class="btn btn-secondary remove-directory"
                                            (click)="removeItemFromDirectory(context)"
                                            (keyDown)="removeItemFromDirectory(context)"
                                    >
                                        <i class="fas fa-turn-down mr-2"></i>
                                        <span>Mover para a raiz</span>
                                    </button>
                                }
                            </div>
                        </div>
                    }
                }
            </div>
        }
    </div>
</div>
